import { Navigate, useParams } from 'react-router-dom';
import { CampaignLanding } from './CampaignLanding';
import { findCampaignBySlug } from './redirects';

/** Renders any campaign's landing page directly at /qr-landing/<slug>. */
export function LandingPreview() {
  const { slug = '' } = useParams();
  const campaign = findCampaignBySlug(slug);

  if (!campaign) {
    return <Navigate to="/promo-and-rewards" replace />;
  }

  return <CampaignLanding content={campaign} />;
}
